import { ServiceDirectorySettings } from '@onlog-public/additional-services-types';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { BehaviorSubject, Subject } from 'rxjs';

import { DefaultAdditionServicesState } from './DefaultAdditionServicesState';
import { DefaultServiceCacheState } from './DefaultServiceCacheState';
import { DefaultServiceFilterAndOrderState } from './DefaultServiceFilterAndOrderState';
import { DefaultServicePropertyCacheState } from './DefaultServicePropertyCacheState';

// Загрузка данных стейта из кэша, если он есть.
const localStorageData =
  JSON.parse(localStorage.getItem('__ONLOG_A_SERVICES_DATA__') ?? '{}') ?? {};
localStorageData?.RootServices?.map((s) => {
  s.settings = ServiceDirectorySettings.RestoreSettings(s.settings);
});

// Контекст дополнительных услуг
export const serviceContext$ = new BehaviorSubject<AdditionServicesState>({
  ...new DefaultAdditionServicesState(),
  ...(localStorageData as Partial<AdditionServicesState>),
});

/**
 * serviceCacheContext$ содержит шину данных дополнительных услуг.
 * Содержит все данные, необходимые для корректного отображения услуг.
 * Пополняется при пересчете услуг, а так же при их первоначальной
 * загрузке.
 */
export const serviceCacheContext$ = new BehaviorSubject<AServiceCache>({
  ...new DefaultServiceCacheState(),
});

/**
 * servicePropertyValueCacheContext$ содержит шину данных для свойств
 * дополнительных услуг. Содержит все сп
 */
export const servicePropertyValueCacheContext$ = new BehaviorSubject<AServicePropertyCache>({
  ...new DefaultServicePropertyCacheState(),
});

/**
 * serviceFilterAndOrderContext$ содержит шину данных для фильтра
 * и сортировки дополнительных услуг по свойствам.
 */
export const serviceFilterAndOrderContext$ = new BehaviorSubject<AServicePropertyFilterAndOrder>({
  ...new DefaultServiceFilterAndOrderState(),
});

/**
 * Шина пересчета значений стоимости услуг. Запускается при изменении полей
 * директорий и услуг.
 *
 * Состояние, передаваемое в шину имеет значение:
 *  - Если передан true, то происходит полный пересчет стейта фильтра свойств
 *  - Если передан false, то стейт фильтра свойств пересчитывается частично, т.е.
 *    считаются только фильтры и сортировки, при этом рассчитанный порядок услуг
 *    сохраняется. Это необходимо чтоб услуги не прыгали, когда пользователь в них
 *    меняет значения.
 */
export const serviceCalculationBus$ = new Subject<{
  isFieldChanges: boolean;
  isNeedChooseVariant: boolean;
}>();

/**
 * Шина загрузки данных услуг. Запускает получение списка услуг и их перерасчет
 * по завершению загрузки.
 */
export const serviceLoadingBus$ = new Subject<boolean>();
